const ENVELOPE_IMPORT_API_REPORT = {
    CSV_BAD_LINE_FORMAT: {
        key: 'csvBadLineFormat',
        getEntity: (items, { numberOfLines } = {}) => {
            if (numberOfLines && items.length === numberOfLines) {
                return 'modal.import.error.csvBadLineFormat.all';
            }
            return items.length > 1
                ? 'modal.import.error.csvBadLineFormat.multiple'
                : 'modal.import.error.csvBadLineFormat.single';
        },
        getData: (items) => ({ linesNumber: items.length })
    },
    SCHEDULED_DATES_IN_THE_PAST: {
        key: 'scheduledDatesInThePast',
        getEntity: () => ('modal.import.error.scheduledDatesInThePast'),
        listEntity: 'modal.import.error.posList',
        getListData: (items) => ({ posTerminalList: items.join(', ') })
    },
    ALREADY_EXISTING_SERIAL_NUMBER_IN_CSV: {
        key: 'alreadyExistingSerialNumberInCsv',
        getEntity: () => ('modal.import.error.alreadyExistingSerialNumberInCsv'),
        listEntity: 'modal.import.error.posList',
        getListData: (items) => ({ posTerminalList: items.join(', ') })
    },
    SERIAL_NUMBERS_NOT_FOUND: {
        key: 'serialNumbersNotFound',
        getEntity: (items) => (
            items.length > 1
                ? 'modal.import.error.serialNumbersNotFound.multiple'
                : 'modal.import.error.serialNumbersNotFound.single'
        ),
        listEntity: 'modal.import.error.posList',
        getListData: (items) => ({ posTerminalList: items.join(', ') })
    },
    EXISTING_ENVELOPE: {
        key: 'existingEnvelope',
        getEntity: (items) => (
            items.length > 1
                ? 'modal.import.error.existingEnvelope.multiple'
                : 'modal.import.error.existingEnvelope.single'
        ),
        listEntity: 'modal.import.error.posList',
        getListData: (items) => ({ posTerminalList: items.join(', ') })
    },
    NOT_FOUND_ORGANIZATION: {
        key: 'notFoundOrganization',
        getEntity: (items) => (
            items.length > 1
                ? 'modal.import.error.notFoundOrganization.multiple'
                : 'modal.import.error.notFoundOrganization.single'
        ),
        listEntity: 'modal.import.error.clientList',
        getListData: (items) => ({ clientList: items.join(', ') })
    },
    UNAUTHORIZED_PROVIDER_FOR_SERIAL_NUMBERS: {
        key: 'unauthorizedProviderForSerialNumbers',
        getEntity: () => ('modal.import.error.unauthorizedProviderForSerialNumbers')
    },
    MANY_ORGANIZATIONS_WITH_SAME_NAME: {
        key: 'manyOrganizationsWithSameName',
        getEntity: (items) => (
            items.length > 1
                ? 'modal.import.error.manyOrganizationsWithSameName.multiple'
                : 'modal.import.error.manyOrganizationsWithSameName.single'
        ),
        listEntity: 'modal.import.error.organizationList',
        getListData: (items) => ({ organizationNameList: items.join(', ') })
    }
};

export default ENVELOPE_IMPORT_API_REPORT;
